export enum MenuType {
  Main = 'MAIN',
  Admin = 'ADMIN',
  Sub = 'SUB',
  SubAdmin = 'SUB_ADMIN',
  None = 'NONE',
}
